// ============================================================================
// ModalTemplate.jsx
// -----------------------------------------------------------------------------
// Template générique pour toutes les fenêtres modales de l'application
// Gère : fond, conteneur, titre, actions, fermeture
// ============================================================================

import theme from "../../styles/theme";
import Button from "../reusable/Forms/Button";

// ============================================================================
// Composant principal
// ============================================================================
const ModalTemplate = ({
  isOpen,
  title,
  width = "600px",
  children,
  onClose,
  onSubmit,
  actions = null, // possibilité d’ajouter un footer personnalisé
}) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999, // <-- plus haut que les cartes
        inset: 0,
      }}
    >
      <div
        style={{
          backgroundColor: theme.colors.background.surface,
          padding: theme.spacing.lg,
          borderRadius: theme.borders.radius.lg,
          width,
          boxShadow: theme.shadows.lg,
          position: "relative",   // stacking context
          zIndex: 10000,           // garantit que le contenu reste au-dessus
        }}
      >
        {/* --- En-tête --- */}
        {title && (
          <>
            <h2 style={{ marginBottom: theme.spacing.sm }}>{title}</h2>
            <hr className="page-separator" style={{ marginBottom: theme.spacing.sm }} />
          </>
        )}

        {/* --- Contenu principal --- */}
        <div style={{ marginBottom: theme.spacing.md }}>{children}</div>

        {/* --- Actions (footer) --- */}
        <hr className="page-separator" style={{ marginBottom: theme.spacing.lg }} />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: theme.spacing.md,
          }}
        >
          {actions ? (
            actions
          ) : (
            <>
              <Button variant="grey" onClick={onClose}>Annuler</Button>
              {onSubmit && (
                <Button variant="blue" onClick={onSubmit}>Enregistrer</Button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// ============================================================================
export default ModalTemplate;
